import React, { useState } from "react";
import TextInput from "./TextInput";

const OtpInputs = ({ onOtpPartChange }) => {
  const [otpParts, setOtpParts] = useState({});

  const combineOtpParts = (obj) => {
    const password = `${obj.otp1}${obj.otp2}${obj.otp3}${obj.otp4}${obj.otp5}${obj.otp6}`;
    onOtpPartChange(password);
  };

  const onChange = (name, value) => {
    combineOtpParts({ ...otpParts, [name]: value });
    setOtpParts({ ...otpParts, [name]: value });
  };

  const inputFocusHandler = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else if (
      (elmnt.keyCode >= 48 && elmnt.keyCode <= 57) ||
      (elmnt.keyCode >= 96 && elmnt.keyCode <= 105)
    ) {
      const next = elmnt.target.tabIndex;
      if (next < 6) {
        elmnt.target.form.elements[next].focus();
      }
    } else return;
  };

  return (
    <div className="otp-box" dir="ltr">
      <TextInput
        className="otpInput"
        tabIndex={1}
        onKeyUp={inputFocusHandler}
        name="otp1"
        autoFocus
        kind="pan"
        maxLength={1}
        value={otpParts.otp1 || ""}
        onChange={onChange}
        onFocus={(event) => event.target.select()}
      />
      <TextInput
        className="otpInput"
        tabIndex={2}
        onKeyUp={inputFocusHandler}
        name="otp2"
        kind="pan"
        maxLength={1}
        value={otpParts.otp2 || ""}
        onChange={onChange}
        onFocus={(event) => event.target.select()}
      />
      <TextInput
        className="otpInput"
        tabIndex={3}
        onKeyUp={inputFocusHandler}
        name="otp3"
        kind="pan"
        maxLength={1}
        value={otpParts.otp3 || ""}
        onChange={onChange}
        onFocus={(event) => event.target.select()}
      />
      <TextInput
        className="otpInput"
        tabIndex={4}
        onKeyUp={inputFocusHandler}
        name="otp4"
        kind="pan"
        maxLength={1}
        value={otpParts.otp4 || ""}
        onChange={onChange}
        onFocus={(event) => event.target.select()}
      />
      <TextInput
        className="otpInput"
        tabIndex={5}
        onKeyUp={inputFocusHandler}
        name="otp5"
        kind="pan"
        maxLength={1}
        value={otpParts.otp5 || ""}
        onChange={onChange}
        onFocus={(event) => event.target.select()}
      />
      <TextInput
        className="otpInput"
        tabIndex={6}
        onKeyUp={inputFocusHandler}
        name="otp6"
        kind="pan"
        maxLength={1}
        value={otpParts.otp6 || ""}
        onChange={onChange}
        onFocus={(event) => event.target.select()}
      />
    </div>
  );
};

export default OtpInputs;
